import BoardMember from "./boardMember";
import Contractor from "./contractor";
import PreEmployment from "./preEmployee";
import Student from "./student";
import Vendor from "./vendor";
import Volunteer from "./volunteer";

import { 
    MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE,
    MEDSTAR_ASSOCIATION_TYPE__BOARD_MEMBER,
    MEDSTAR_ASSOCIATION_TYPE__CONTRACTOR,
    MEDSTAR_ASSOCIATION_TYPE__STUDENT,
    MEDSTAR_ASSOCIATION_TYPE__VENDOR,
    MEDSTAR_ASSOCIATION_TYPE__VOLUNTEER
} from "../../../../sitel/commons/utilities/medstarAssociationType";


export default function EmploymentInformationSection({medstarAssociationType,register,errors}){
    
    switch(medstarAssociationType){
        case MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE:
            return <PreEmployment register={register} errors={errors} />

        case MEDSTAR_ASSOCIATION_TYPE__VENDOR:
            return <Vendor register={register} errors={errors} />

        case MEDSTAR_ASSOCIATION_TYPE__STUDENT:
            return <Student register={register} errors={errors} />

        case MEDSTAR_ASSOCIATION_TYPE__CONTRACTOR:
            return <Contractor register={register} errors={errors} />

        case MEDSTAR_ASSOCIATION_TYPE__BOARD_MEMBER:
            return <BoardMember register={register} errors={errors} />

        case MEDSTAR_ASSOCIATION_TYPE__VOLUNTEER:
            return <Volunteer register={register} errors={errors} />

        default:
            throw Error('No medstar association');
    }
}
